module.exports = __webpack_public_path__ + "static/img/qi_11.83a5d32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_11.jpg
// module id = Mami
// module chunks = 1